import { Component, Input } from '@angular/core';
import { NgbTabChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { NgxSmartModalService } from 'ngx-smart-modal';
import * as _ from 'lodash';
import { SxInternalStateDesignerService } from 'app/private/sxfdesigner/services/internal-state-designer-service';
import { DesignerContextType } from 'app/private/sxfdesigner/types/designer-context-type';

@Component({
  selector: 'sx-view-engine-modal',
  templateUrl: './view-engine-modal.component.html',
})
export class SxViewEngineModalComponent {
  // Contexto del designer.
  @Input() designerContext: DesignerContextType;
  
  activeTab = 'overView';

  constructor(
    private ngxSmartModalService: NgxSmartModalService,
    private internalState: SxInternalStateDesignerService
  ) {}

  changingTab(event: NgbTabChangeEvent) {
    this.activeTab = event.nextId;
  }

  promptNewRule(propName) {
    this.internalState.setCurrentPropertyModal(propName);
    this.ngxSmartModalService.getModal('goToNewRuleModal').open();
  }

  closeModal(): void {
    this.designerContext.selectedDesigner = null;
    this.ngxSmartModalService.resetModalData('viewEngineModal');
    this.ngxSmartModalService.getModal('viewEngineModal').close();
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/modals/view-engine/view-engine-modal.component.ts